// Selector de proveedor de telefonía (Fase 7) — control compacto para el
// header del Layout, junto a los toggles de país (lo menos invasivo: dos pills
// del mismo lenguaje visual). Persiste la preferencia por usuario en el CRM
// (PUT /preferences/phone) y muestra el estado del softphone cuando el
// proveedor es Telnyx (registrando / desconectado con botón de reintento).
//
// Solo se muestra con la sesión CRM conectada y la preferencia cargada: si el
// usuario no usa el CRM, el header queda exactamente como estaba.

import { memo } from "react";
import { PROVIDER_LABELS } from "../../api/crmPhone";
import { PhoneProvider } from "../../api/crmTypes";
import { useCrmSession } from "../../context/CrmSessionContext";
import { usePhone } from "../../context/PhoneContext";

const PROVIDERS: PhoneProvider[] = ["cloudtalk", "telnyx"];

function PhoneProviderSelectorInner() {
  const { connected } = useCrmSession();
  const { provider, setProvider, prefsReady, softphone, reconnectSoftphone } =
    usePhone();

  if (connected !== true || !prefsReady) return null;

  return (
    <div
      role="radiogroup"
      aria-label="Proveedor de telefonía"
      style={{ display: "flex", alignItems: "center", gap: "0.35rem" }}
    >
      {PROVIDERS.map((p) => {
        const active = provider === p;
        return (
          <button
            key={p}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => setProvider(p)}
            title={`Llamar con ${PROVIDER_LABELS[p]}`}
            style={{
              padding: "0.3rem 0.7rem",
              borderRadius: "999px",
              border: active ? "1px solid #0069d9" : "1px solid #dee2e6",
              background: active ? "#0069d9" : "white",
              color: active ? "white" : "#1f2933",
              fontSize: "0.78rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {PROVIDER_LABELS[p]}
          </button>
        );
      })}
      {provider === "telnyx" && softphone.status === "registering" && (
        <span style={{ fontSize: "0.72rem", color: "#856404" }}>
          registrando…
        </span>
      )}
      {provider === "telnyx" && softphone.status === "offline" && (
        <button
          type="button"
          onClick={reconnectSoftphone}
          title={softphone.error ?? "Softphone desconectado"}
          style={{
            fontSize: "0.72rem",
            color: "#dc3545",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
            fontWeight: 600,
          }}
        >
          desconectado · reintentar
        </button>
      )}
    </div>
  );
}

// memo: vive en el header de TODAS las páginas; solo re-renderiza si cambian
// provider / softphone / sesión.
const PhoneProviderSelector = memo(PhoneProviderSelectorInner);
export default PhoneProviderSelector;
